<template>
    <div class="mt-10 flex w-full space-x-5">
        <div
            v-for="(groupItems, groupIndex) in groupsItems"
            :key="groupIndex"
            :style="isMounted && isDesktop ? 'perspective: 1500px' : ''"
            class="flex w-full flex-col space-y-5">
            <OurAdvantagesCard
                v-for="(item, index) in groupItems"
                :key="index"
                :class="[
                    index ? 'grow' : '',
                    isChangedClass ? (index === 0 ? 'lg:!min-h-52' : '') : '',
                ]"
                class="relative flex flex-col justify-between">
                <div>
                    <h2
                        v-html="item.title"
                        class="text-24/133 font-semibold" />
                    <div
                        v-html="item.description"
                        :class="[
                            { 'lg:max-xl:pr-24': item.absoluteIcon },
                            item.additionalSpace,
                        ]"
                        class="mt-3 w-full max-w-[20rem] text-16/148 text-accent-100" />
                </div>
                <div
                    :class="{
                        'lg:absolute': item.absoluteIcon,
                    }"
                    class="bottom-3 right-3 mt-3 flex justify-end">
                    <Component :is="item.icon" />
                </div>
            </OurAdvantagesCard>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useWindowSize } from '@vueuse/core'

import OurAdvantagesCard from '~/components/pages/directions/our-advantages-section/OurAdvantagesCard.vue'
import type { IOurAdvantagesItem } from '~/components/pages/directions/our-advantages-section/our-advantages.types'

const props = defineProps({
    items: {
        type: Array as PropType<IOurAdvantagesItem[]>,
        required: true,
    },
    isChangedClass: {
        type: Boolean,
        default: false,
    },
})

const { width } = useWindowSize()
const isMounted = ref(false)
const isDesktop = computed(() => {
    return width.value && width.value >= 1024
})

const groupsItems = computed(() => {
    return [
        props.items.slice(0, 2),
        props.items.slice(2, 4),
        props.items.slice(4, 6),
    ]
})

onMounted(() => {
    isMounted.value = true
})
</script>
